import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ml_asset, use_slice_workspace } from '@/hooks/store/use_slices';
import { ViewDiffusionModelTimer } from '@/pages/_base/views/ViewDiffusionModelTimer';
import { set_interval } from '@/utils/utils_client';
import { DTODiffusionModelUDBase } from '@shared/dto/+diffusion_model/+ud/_base/dto_diffusion_model_ud_base';
import { DTO__ml_asset_reservation } from '@shared/dto/+model/reservation/DTO__ml_asset_reservation';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useState } from 'react';

interface Props {
  diffusion_model: DTODiffusionModelUDBase;
}

export function DiffusionModelsCellExpiredAt({ diffusion_model }: Props) {
  const { reservations_current_workspace_active_map } = use_slice_ml_asset(['reservations_current_workspace_active_map']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [value, set_value] = useState(0);

  const [remaining, set_remaining] = useState(0);

  /*
   * EFFECTS
   */
  use_effect(() => {
    const current_model_reservations_map = reservations_current_workspace_active_map.get(diffusion_model._id);
    if (!current_model_reservations_map) return set_value(0); //not loaded yet

    if (current_model_reservations_map.size === 0) return set_value(0); //no active reservations

    let current_model_reservations_list = Array.from(current_model_reservations_map.values()).sort(DTO__ml_asset_reservation.sort_by_expired_at_z_to_a);

    let latest_reservation = current_model_reservations_list[0];

    set_value(latest_reservation.expired_at);
  }, [workspace_current._id, reservations_current_workspace_active_map, diffusion_model._id]);

  use_effect(() => {
    if (value === 0) return;

    update_remaining();

    const interval_id = set_interval(update_remaining, 1000);

    return () => clearInterval(interval_id);
  }, [value]);

  /*
   * METHODS
   */

  function update_remaining() {
    const now = timestamp_ms();
    const difference_time = value - now;

    set_remaining(difference_time > 0 ? difference_time : 0);
  }

  /*
   * HTML
   */

  if (value === 0) return null;
  if (remaining === 0) return null;

  return (
    <ViewDiffusionModelTimer
      time_left={remaining}
      className="w-fit bg-component px-2 py-1 rounded-md text-sm text-page-foreground border border-component-border"
    />
  );
}
